export class GoogleWorkspaceDriveRestoreOptions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "folderName",
            "baseName": "folderName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceDriveRestoreOptions.attributeTypeMap;
    }
    constructor() {
    }
}
